import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { axiosInstance } from '../../utils/axios';
import {
  createPlanFailure,
  createPlanRequest,
  createPlanSuccess,
  editPlanFailure,
  editPlanRequest,
  editPlanSuccess,
  fetchPlanById,
  fetchPlanByIdFailure,
  fetchPlanByIdSuccess,
  fetchPlansFailure,
  fetchPlansRequest,
  fetchPlansSuccess,
} from './planSlice';

function* fetchPlansSaga(action) {
  try {
    const { search_key, page, limit } = action.payload;
    const params = {
      name: search_key,
      page,
      limit,
    };
    const response = yield call(axiosInstance.get, '/plans', { params });
    yield put(fetchPlansSuccess(response.data));
  } catch (error) {
    yield put(fetchPlansFailure(error.message));
  }
}

function* fetchPlanByIdSaga(action) {
  try {
    const response = yield call(axiosInstance.get, `/plans/${action.payload}`);
    yield put(fetchPlanByIdSuccess(response.data));
  } catch (error) {
    yield put(fetchPlanByIdFailure(error.message));
  }
}

function* editPlanRequestSaga(action) {
  try {
    const { _id, __v, createdAt, updatedAt, ...sanitizedPayload } = action.payload;
    const response = yield call(axiosInstance.put, `/plans/${_id}`, sanitizedPayload);
    yield put(editPlanSuccess(response.data));
  } catch (error) {
    yield put(editPlanFailure(error.response.data.error));
  }
}

function* createPlanSaga(action) {
  try {
    const response = yield call(axiosInstance.post, '/plans', action.payload);
    yield put(createPlanSuccess(response.data));
  } catch (error) {
    yield put(createPlanFailure(error.response.data.errors));
  }
}

function* planSaga() {
  yield takeLatest(fetchPlansRequest.type, fetchPlansSaga);
  yield takeEvery(fetchPlanById.type, fetchPlanByIdSaga);
  yield takeLatest(createPlanRequest.type, createPlanSaga);
  yield takeLatest(editPlanRequest.type, editPlanRequestSaga);
}

export default planSaga;
